import { Container, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { ItemLetter, ItemWord } from "../../styles/AfriqualeosStyles";
import { motion } from "framer-motion";
import { useTheme } from "@mui/material/styles";
import { words } from "../../data/AfriqualeosWords";

const container = {
  hidden: { scale: 1 },
  view: {
    scale: 1,
    transition: {
      staggerChildren: 0.1,
      type: "spring",
      stiffness: 400,
    },
  },
};

const item = {
  hidden: { scale: 0 },
  hover: {
    y: -10,
  },
  view: {
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 150,
    },
  },
};

const AfriqualeosMean = () => {
  const [order, setOrder] = useState(0);
  const [OneTwo, setOneTwo] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setOrder((order) => {
        if (order !== 7) {
          return order + 1;
        } else {
          return 0;
        }
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (order === 7) {
      setOneTwo(!OneTwo);
    }
  }, [order]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        p: 0,
        display: {
          xl: "block",
          lg: "none",
          md: "none",
          sm: "none",
          xs: "none",
        },
      }}
    >
      <Stack
        component={motion.div}
        initial="hidden"
        whileInView="view"
        direction="column"
        variants={container}
        height="100vh"
        alignItems="left"
        justifyContent="center"
      >
        {words.map((item, i) => (
          <Item key={i}>
            {order === item.id ? (
              //
              <ItemWord>
                {typeof item.word === "string"
                  ? item.word
                  : OneTwo
                  ? item.word[0]
                  : item.word[1]}
              </ItemWord>
            ) : (
              <ItemLetter>{item.letter}</ItemLetter>
            )}
          </Item>
        ))}
      </Stack>
    </Box>
  );
};

const Item = ({ children, ...other }) => {
  const theme = useTheme();
  return (
    <Box
      {...other}
      component={motion.div}
      variants={item}
      whileHover={{ x: -10 }}
      drag="x"
      dragConstraints={{ left: 0, right: 0, top: 0, bottom: 0 }}
      dragElastic={0.3}
    >
      {children}
    </Box>
  );
};

export default AfriqualeosMean;
